module.exports = __webpack_public_path__ + "img/roulette-gray.f67367cb.svg";